'use client';

import { c as _c } from "react/compiler-runtime";
import { externalLiveGuideStepFour, externalLiveGuideStepOne, externalLiveGuideStepThree, externalLiveGuideStepTwo, externalRecordGuideStepFour, externalRecordGuideStepOne, externalRecordGuideStepThree, externalRecordGuideStepTwo } from '@module/constants/guide';
import { cn } from '@module/lib/utils';
import useModalStore from '@module/stores/useModalStore';
import { BaseRightArrow } from '@module/svg/icons';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import { useState } from 'react';
import GuideStepList from '../_components/GuideStepList';
const pcliveGuideStepList = [externalLiveGuideStepOne, externalLiveGuideStepTwo, externalLiveGuideStepThree, externalLiveGuideStepFour];
const recordGuideStepList = [externalRecordGuideStepOne, externalRecordGuideStepTwo, externalRecordGuideStepThree, externalRecordGuideStepFour];
function PcExternalGuideContainer() {
  const $ = _c(42);
  const {
    pushModal
  } = useModalStore();
  const [tab, setTab] = useState("live");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p>송출 프로그램의 자세한 안내는 아래 버튼 클릭하여 확인</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== pushModal) {
    t1 = () => {
      pushModal({
        type: "TRANSMISSION_MODAL"
      });
    };
    $[1] = pushModal;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <BaseRightArrow style={{
      color: "var(--baseFg)",
      marginLeft: 12
    }} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="flex w-[440px] flex-col items-start gap-3 rounded-[8px] border border-borderBg02 p-4">{t0}<BaseButton size="md" onClick={t1}>OBS / PRISM 설정 알아보기{t2}</BaseButton></div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <br />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p>** 팬더티비에서는 다양한 방송 콘텐츠를 위하여, 자체 {t4}도우미 기능도 제공하고 있습니다.{t5}팬더티비 도우미 페이지에서 프리셋을 복사한 뒤,<br />OBS 소스 목록에 추가 하여 사용해 보세요!</p>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== pushModal) {
    t7 = () => {
      pushModal({
        type: "HELPER_WIDGET_GUIDE_MODAL"
      });
    };
    $[9] = pushModal;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <BaseRightArrow style={{
      color: "var(--baseFg)",
      marginLeft: 12
    }} />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7) {
    t9 = <div className="flex w-[440px] flex-col items-start gap-3 rounded-[8px] border border-borderBg02 p-4">{t6}<BaseButton size="md" onClick={t7}>도우미 위젯 설정 알아보기{t8}</BaseButton></div>;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t3 || $[15] !== t9) {
    t10 = {
      stepIndex: 2,
      element: <div className="mt-3 flex flex-col gap-3 text-baseFg">{t3}{t9}</div>
    };
    $[14] = t3;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      stepIndex: 3,
      element: <div className="mt-6 flex w-[440px] flex-col items-start gap-3 rounded-[8px] border border-borderBg02 p-4"><p className="font-bold text-baseFg">외부 앱 방송 시 아래의 값으로 설정해 주세요.</p><ol><li>· 비디오 비트레이트 : 8,000kbps 이하</li><li>· 오디오 비트레이트 : 320kbps 이하</li><li>· FPS : 30 또는 60(720p 이상 시)</li><li>· 키프레임 간격 : 1~2초</li></ol></div>
    };
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10) {
    t12 = [t10, t11];
    $[18] = t10;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const liveAdditionalElements = t12;
  const t13 = tab === "live";
  let t14;
  if ($[20] !== t13) {
    t14 = cn("relative font-semibold", {
      "text-colorFg22 after:absolute after:top-0 after:h-1 after:w-1 after:rounded-[50%] after:bg-colorFg22 after:content-[\"\"]": t13
    });
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setTab("live");
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t14) {
    t16 = <button type="button" className={t14} onClick={t15}>LIVE 방송</button>;
    $[23] = t14;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  const t17 = tab === "record";
  let t18;
  if ($[25] !== t17) {
    t18 = cn("relative ml-6 font-semibold", {
      "text-colorFg22 after:absolute after:top-0 after:h-1 after:w-1 after:rounded-[50%] after:bg-colorFg22 after:content-[\"\"]": t17
    });
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setTab("record");
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== t18) {
    t20 = <button type="button" className={t18} onClick={t19}>녹화방송</button>;
    $[28] = t18;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== t16 || $[31] !== t20) {
    t21 = <div className="mt-5 mb-[45px] text-colorFg18">{t16}{t20}</div>;
    $[30] = t16;
    $[31] = t20;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== liveAdditionalElements || $[34] !== tab) {
    t22 = tab === "live" && <div className="space-y-6"><GuideStepList stepList={pcliveGuideStepList} additionalElements={liveAdditionalElements} /></div>;
    $[33] = liveAdditionalElements;
    $[34] = tab;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== tab) {
    t23 = tab === "record" && <div className="space-y-6"><GuideStepList stepList={recordGuideStepList} /></div>;
    $[36] = tab;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t21 || $[39] !== t22 || $[40] !== t23) {
    t24 = <div>{t21}{t22}{t23}</div>;
    $[38] = t21;
    $[39] = t22;
    $[40] = t23;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  return t24;
}
export default PcExternalGuideContainer;